import React from "react";
import {useSelector} from "react-redux";
import {getPlayerMatchFixture} from "modules/selectors";
import styled from "styled-components";
import {IMatch} from "modules/types/json";
import {SquadLogo} from "components/SquadLogo";
import {Nullable} from "modules/types";
import {DateTime} from "luxon";
import {media} from "assets/media";

const Wrapper = styled.div``;

interface IProps {
	playerId: number;
}

export const PlayerFixtures: React.FC<IProps> = ({playerId}) => {
	const fixtures = useSelector(getPlayerMatchFixture);

	return (
		<Wrapper>
			{fixtures.map((fixture) => (
				<Fixture key={fixture.id} fixture={fixture} />
			))}
		</Wrapper>
	);
};

const SFixture = styled.div`
	border-bottom: 1px solid #dddddd;
	padding: 17px 26px 12px 26px;
`;

const MatchDetails = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 14px;

	p {
		color: ${({theme}) => theme.text_color};
		font-size: 10px;
		letter-spacing: 0;
		line-height: 12px;
		margin: 0;
	}
`;

const MatchScore = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
`;

const Stadium = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 8px;
	width: 40%;

	h3 {
		color: ${({theme}) => theme.text_color};
		font-size: 14px;
		letter-spacing: 0;
		line-height: 17px;
		padding-left: 12px;
		padding-right: 12px;
		margin: 0;
		font-weight: normal;
	}

	img {
		height: 30px;
		width: auto;
	}

	&.reverse {
		flex-direction: row-reverse;

		h3 {
			text-align: right;
		}
	}

	@media screen and ${media.lessThanMD} {
	}
`;

const Info = styled.p`
	color: ${({theme}) => theme.text_color};
	text-transform: capitalize;
	font-size: 14px;
	letter-spacing: 0;
	line-height: 17px;
	text-align: center;
	width: 20%;
`;

const Fixture: React.FC<{fixture: IMatch}> = ({fixture}) => {
	const fixtureDate = new Date(fixture.date);
	const dateTime = DateTime.fromJSDate(fixtureDate);

	const leftDate = dateTime.toFormat("ccc d MMM");
	const rightDate = dateTime.toFormat("T");

	const hasScore = (score: Nullable<number> | undefined) => {
		return score === null || score === undefined;
	};

	const homeScore = hasScore(fixture.home_score) ? " " : fixture.home_score;
	const awayScore = hasScore(fixture.away_score) ? " " : fixture.away_score;

	return (
		<SFixture>
			<MatchDetails>
				<p>{leftDate}</p>
				<p>
					{fixture.venue_name}, {rightDate}
				</p>
			</MatchDetails>
			<MatchScore>
				<Stadium className="stadium">
					<SquadLogo squadId={fixture.home_squad_id} />
					<h3>{fixture.home_squad_name}</h3>
				</Stadium>
				<Info>
					{homeScore}-{awayScore}
				</Info>
				<Stadium className="stadium reverse">
					<SquadLogo squadId={fixture.away_squad_id} />
					<h3>{fixture.away_squad_name}</h3>
				</Stadium>
			</MatchScore>
		</SFixture>
	);
};
